import { MixpanelClient } from '@mathflat/shared/@modules/mixpanel/MixpanelClient'
import { deviceType } from 'react-device-detect'

import { envUtils } from '../envUtils'
import type { EventSchema } from './schema/event.schema'
import type { GlobalEventPropertiesSchema } from './schema/globalEventProperties.schema'
import type { UserPropertiesSchema } from './schema/userProperties.schema'

type MixpanelInstance = ReturnType<typeof MixpanelClient.getMixpanel>

export class StudentMixpanelClient extends MixpanelClient<EventSchema> {
  constructor() {
    super(
      import.meta.env.VITE_MIXPANEL_PROJECT_TOKEN,
      {
        track_pageview: true,
        persistence: 'localStorage',
        cookie_name: 'version3',
        cross_subdomain_cookie: false,
        autocapture: {
          click: false,
          pageview: 'url-with-path',
          scroll: true,
          submit: false,
          input: false,
          capture_text_content: false,
        },
        app_host: window.location.hostname,
        debug: localStorage.getItem('MIXPANEL_DEBUG') === 'true',
        batch_requests: envUtils.isLive,
        // 기본값을 opt-out 으로 두고, 프리미엄 학원 학생일 때만 명시적으로 opt-in 한다.
        opt_out_tracking_by_default: true,
      },
      {
        globalPropertiesVersion: 'v1.0@2025-10-15',
        userPropertiesVersion: 'v1.0@2025-10-15',
      },
    )
  }

  override initialize() {
    super.initialize(deviceType)

    // 여기서 globalProperty 버전관리하기
    // 버저닝 시작하기 이전의 값들은 삭제
    if (!this.getEventProperty('globalPropertiesVersion')) {
      this.unregister('academy')
      this.unregister('parent')
      this.unregister('student')
    }
  }

  override setGlobalEventProperty(props: Partial<GlobalEventPropertiesSchema>) {
    super.setGlobalEventProperty(props)
  }

  override track<K extends Extract<keyof EventSchema, string>>(
    eventName: K,
    properties?: EventSchema[K] extends never ? never : EventSchema[K],
    optionsOrCallback?: Parameters<MixpanelInstance['track']>[2],
    callback?: Parameters<MixpanelInstance['track']>[3],
  ) {
    super.track(eventName, properties, optionsOrCallback, callback)
  }

  override setUserProperty(props: Partial<UserPropertiesSchema>) {
    super.setUserProperty(props)
  }

  override optInTracking(options?: Parameters<MixpanelInstance['opt_in_tracking']>[0]) {
    super.optInTracking({ track: () => undefined, ...options })
  }
}

export const mixpanelClient = new StudentMixpanelClient()
